export const FFTH_ROUTER_PENALTY_TAX_FREE = 139
export const ADSL_ROUTER_PENALTY_TAX_FREE = 79
export const AGILE_TV_PENALTY_TAX_FREE = 100
